import { useBackend } from "../../services";

export const useDeletePasskey = () => {
  const { deleteRequest } = useBackend();
  const deletePasskey = (parameters: IDeletePasskeyParameters) =>
    deleteRequest("passkeys", parameters);
  return { deletePasskey };
};

export interface IDeletePasskeyParameters {
  id: string;
}
